module.exports = __webpack_public_path__ + "static/media/my-needs-icon-active.e95fd7d6.svg";